import React from "react";
import { formatRange } from "../../pages/vacationDates";
import Avatar from "./Avatar";
import CoverageBar, { coverageState } from "./CoverageBar";

export default function EmployeeCard({ emp, selected, onSelect }) {
  const covered = emp.nextAbsence?.rows_covered ?? 0;
  const state = coverageState(covered, emp.rows_total);
  const badgeClass = state ? `vs-badge--${state}` : null;
  const showCoverage = Boolean(emp.nextAbsence && emp.rows_total > 0);
  return (
    <li>
      <button
        type="button"
        className={`vs-emp-card${selected ? " vs-emp-card--active" : ""}`}
        aria-pressed={selected}
        onClick={() => onSelect(emp.id)}
      >
        <Avatar name={emp.full_name} />
        <span className="vs-emp-card__body">
          <span className="vs-emp-card__name">{emp.full_name}</span>
          <span className="vs-emp-card__meta">
            {emp.nextAbsence ? (
              <span className="vs-mono">
                {formatRange(emp.nextAbsence.start_date, emp.nextAbsence.end_date)}
              </span>
            ) : emp.rows_total === 0 ? (
              "нет клиентов"
            ) : null}
          </span>
        </span>
        {showCoverage && (
          <span className={`vs-emp-card__count vs-badge ${badgeClass}`}>
            {covered}/{emp.rows_total}
          </span>
        )}
        {showCoverage && (
          <CoverageBar
            compact
            covered={covered}
            total={emp.rows_total}
            label={`${emp.full_name}: закрыто ${covered} из ${emp.rows_total}`}
          />
        )}
      </button>
    </li>
  );
}
